import { useEnvConfigStore } from "@/store/env.store";
import { useUserInfo } from "@/store/userInfo.store";
import axios from "axios";


export class SpanSupportApiServices{
    async postMethod(url: string, data: any) {
      const userInfoStore = useUserInfo()
      const userInfo = userInfoStore.UserInfoFromLocalStorage
        url =  useEnvConfigStore().envInfo?.Span_Support_API_Url + url
          try {
            const response = await axios({
              method: "post",
              headers: {
                'Authorization': "Bearer " + (userInfoStore.UserLoginInfo?.JwtToken || userInfo?.JwtToken),
                'CallFrom': "AIChatBot"
              },
              url,
              data,
            });
            return response.data;
          } catch (err: any) {
            if (
              err.response !== undefined &&
              err.response.status !== undefined &&
              err.response.status === 401
            ) {
              userInfoStore.Logout()
         }
          }
        } 
        async getMethod(url: string, data: any='') {
          const userInfoStore = useUserInfo()
          const userInfo = userInfoStore.UserInfoFromLocalStorage
          url =  useEnvConfigStore().envInfo?.Span_Support_API_Url + url
            try {
              const response = await axios({
                method: "get",
                headers: {
                  'Authorization': "Bearer " + (userInfoStore.UserLoginInfo?.JwtToken || userInfo?.JwtToken),
                  'CallFrom': "AIChatBot"
                },
                url,
                params:data,
              });
              return response.data;
            } catch (err: any) {
              if (
                err.response !== undefined &&
                err.response.status !== undefined &&
                err.response.status === 401
              ) {
                userInfoStore.Logout()
           }
            }
          } 

          async pdfPostMethod(url: string, data: any) {
            const userInfoStore = useUserInfo()
            const userInfo = userInfoStore.UserInfoFromLocalStorage
            url =  useEnvConfigStore().envInfo?.Span_Support_API_Url + url
              try {
                const response = await axios({
                  method: "post",
                  headers: {
                    'Authorization': "Bearer " + (userInfoStore.UserLoginInfo?.JwtToken || userInfo?.JwtToken),
                    'CallFrom': "AIChatBot"
                  },
                  url,
                  data,
                  responseType: 'blob'
                });
                return response.data;
              } catch (err: any) {
                if (
                  err.response !== undefined &&
                  err.response.status !== undefined &&
                  err.response.status === 401
                ) {
                 userInfoStore.Logout()
             }
              }
            } 
      }
